import(/* webpackMode: "eager" */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft\\src\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft\\src\\GlobalRedux\\Provider.js");
